import { Suspense, useEffect } from 'react';
import { ShellEvent } from '@appd/fso-ui-shell/container';
import { useDashboardJson } from '../../../hooks';
import { TemplateRenderer } from '.';
import { DashboardLoading } from '../componentVariations/loading';
import { logger } from '../../../utils';

interface DashboardRendererProps {
  name: string;
}

export const DashboardRenderer = (props: DashboardRendererProps): JSX.Element | null => {
  const { name } = props;

  // todo: check and improve the use of the useDashboardJson hook
  // from the DashboardRenderer and TemplateRenderer
  const json = useDashboardJson({ name });
  const hideTimeRangeSelector = json?.globals?.hideTimeRangeSelector === true;

  useEffect(() => {
    ShellEvent.emit('selectedTemplateName', name);
    if (hideTimeRangeSelector !== undefined) {
      ShellEvent.emit('hideTimeRangeSelector', hideTimeRangeSelector);
    }
  }, []);

  if (!json) {
    return <div>Dashboard '{name}' not found</div>;
  }

  logger.log('Dashboard Renderer', { json });
  return (
    <Suspense fallback={<DashboardLoading />}>
      <TemplateRenderer name={name} />
    </Suspense>
  );
};
